// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: rgb(245, 245, 245);
}

.App {
  text-align: center;
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  /* Konqueror HTML */
  /* Old versions of Firefox */
  /* Internet Explorer/Edge */
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox 8*/
}

.App-Header {
  position: fixed;
  z-index: 1;
  background-color: #4a4a4d;
  width: 100%;
  height: 2rem;
  top: 0px;
  color: white;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
}

.Content-Container {
  width: 100%;
  height: 80vh;
  display: flex;
  justify-content: space-between;
  color: black;
}

.TaskDescription {
  text-align: left;
  margin: 70px 10px 10px 20px;
  width: 30%;
}

.Task-Objectives {
  background-color: #cfe8fc;
}

.Submit-Controller {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #101010;
  text-transform: none !important;
  outline: black;
}

.Questionnaire {
  display: flex;
  flex-direction: column;
  margin: auto;
  width: 90%;
}

.Assist-Information {
  margin-top: 20px;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-link {
  color: #104f5f;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.rowFlex {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 20px;
}

.targetImageContainer {
  width: 17rem;
  height: 17rem;
  justify-content: flex-start;
  position: relative;
  font-size: small;
  align-items: self-start;
  justify-content: center; /* horizontal */
}

.targetImageBox {
  width: 17rem;
  height: 17rem;
  border-radius: 0.5rem;
  border: 1px solid #eeeeef;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  background-color: #ffffff;

  /* Center only the content area */
  display: flex;
  align-items: center;
  justify-content: center;
}

.targetImage {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  border-radius: 0.5rem;
}

.ratingImageContainer {
  width: 35rem;
  font-size: small;
}

.ratingImageBox {
  width: 35rem;
  height: 35rem;
  border-radius: 0.5rem;
  border: 1px solid #eeeeef;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  background-color: #ffffff;

  /* center content */
  display: flex;
  align-items: center;
  justify-content: center;
}

.ratingImage {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  border-radius: 0.5rem;
}

.ratingInputContainer {
  display: block;
  margin-top: 3rem;
  text-align: center;
  font-size: small;
  padding: 0;
}

.main {
  margin-top: 4rem;
  margin-left: 0;
  margin-right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: medium;
  width: 100%;
  max-width: 960px;
  text-align: left;
}

.debugBox {
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  padding: 0.5rem;
  background-color: #fff;
}

#iterateController {
  width: 35rem;
}

/* ############## speech bubble ########## */

/* Base speech bubble */
.speech-bubble {
  position: relative;
  background: #ffffff;
  border-radius: 12px;
  padding: 12px 16px;
  margin: 10px;
  max-width: 250px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid #ddd;
  word-wrap: break-word;
  overflow-wrap: break-word;
  box-sizing: border-box;
  font-size: 13px;
}

/* Speech bubble pointing down (above slider) */
.speech-bubble-down::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-top: 12px solid #ffffff;
}

.speech-bubble-down::before {
  content: '';
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-top: 14px solid #ddd;
}

/* Speech bubble for submit button */
.speech-bubble-up-left::after {
  content: '';
  position: absolute;
  top: -10px;
  left: 20px;
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #ffffff;
}

.speech-bubble-up-left::before {
  content: '';
  position: absolute;
  top: -12px;
  left: 19px;
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-bottom: 14px solid #ddd;
}

/* Speech bubble for satisfied button */
.speech-bubble-up-right::after {
  content: '';
  position: absolute;
  top: -10px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #ffffff;
}

.speech-bubble-up-right::before {
  content: '';
  position: absolute;
  top: -12px;
  right: 19px;
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-bottom: 14px solid #ddd;
}

.speech-bubble p {
  margin: 0;
  line-height: 1.3;
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,WAAW;EAEX,mBAAmB;EAEnB,4BAA4B;EAE5B,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;iFAC+E;AACjF;;AAEA;EACE,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB,EAAE,eAAe;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;;EAEzB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;;EAEzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA,4CAA4C;;AAE5C,uBAAuB;AACvB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: rgb(245, 245, 245);\n}\n\n.App {\n  text-align: center;\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Old versions of Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox 8*/\n}\n\n.App-Header {\n  position: fixed;\n  z-index: 1;\n  background-color: #4a4a4d;\n  width: 100%;\n  height: 2rem;\n  top: 0px;\n  color: white;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px;\n}\n\n.Content-Container {\n  width: 100%;\n  height: 80vh;\n  display: flex;\n  justify-content: space-between;\n  color: black;\n}\n\n.TaskDescription {\n  text-align: left;\n  margin: 70px 10px 10px 20px;\n  width: 30%;\n}\n\n.Task-Objectives {\n  background-color: #cfe8fc;\n}\n\n.Submit-Controller {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #101010;\n  text-transform: none !important;\n  outline: black;\n}\n\n.Questionnaire {\n  display: flex;\n  flex-direction: column;\n  margin: auto;\n  width: 90%;\n}\n\n.Assist-Information {\n  margin-top: 20px;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-link {\n  color: #104f5f;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.rowFlex {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 20px;\n}\n\n.targetImageContainer {\n  width: 17rem;\n  height: 17rem;\n  justify-content: flex-start;\n  position: relative;\n  font-size: small;\n  align-items: self-start;\n  justify-content: center; /* horizontal */\n}\n\n.targetImageBox {\n  width: 17rem;\n  height: 17rem;\n  border-radius: 0.5rem;\n  border: 1px solid #eeeeef;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  background-color: #ffffff;\n\n  /* Center only the content area */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.targetImage {\n  max-height: 100%;\n  max-width: 100%;\n  object-fit: contain;\n  border-radius: 0.5rem;\n}\n\n.ratingImageContainer {\n  width: 35rem;\n  font-size: small;\n}\n\n.ratingImageBox {\n  width: 35rem;\n  height: 35rem;\n  border-radius: 0.5rem;\n  border: 1px solid #eeeeef;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  background-color: #ffffff;\n\n  /* center content */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ratingImage {\n  max-height: 100%;\n  max-width: 100%;\n  object-fit: contain;\n  border-radius: 0.5rem;\n}\n\n.ratingInputContainer {\n  display: block;\n  margin-top: 3rem;\n  text-align: center;\n  font-size: small;\n  padding: 0;\n}\n\n.main {\n  margin-top: 4rem;\n  margin-left: 0;\n  margin-right: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: medium;\n  width: 100%;\n  max-width: 960px;\n  text-align: left;\n}\n\n.debugBox {\n  border: 1px solid #ccc;\n  border-radius: 0.5rem;\n  padding: 0.5rem;\n  background-color: #fff;\n}\n\n#iterateController {\n  width: 35rem;\n}\n\n/* ############## speech bubble ########## */\n\n/* Base speech bubble */\n.speech-bubble {\n  position: relative;\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 12px 16px;\n  margin: 10px;\n  max-width: 250px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 2px solid #ddd;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  box-sizing: border-box;\n  font-size: 13px;\n}\n\n/* Speech bubble pointing down (above slider) */\n.speech-bubble-down::after {\n  content: '';\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 12px solid transparent;\n  border-right: 12px solid transparent;\n  border-top: 12px solid #ffffff;\n}\n\n.speech-bubble-down::before {\n  content: '';\n  position: absolute;\n  bottom: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 14px solid transparent;\n  border-right: 14px solid transparent;\n  border-top: 14px solid #ddd;\n}\n\n/* Speech bubble for submit button */\n.speech-bubble-up-left::after {\n  content: '';\n  position: absolute;\n  top: -10px;\n  left: 20px;\n  width: 0;\n  height: 0;\n  border-left: 12px solid transparent;\n  border-right: 12px solid transparent;\n  border-bottom: 12px solid #ffffff;\n}\n\n.speech-bubble-up-left::before {\n  content: '';\n  position: absolute;\n  top: -12px;\n  left: 19px;\n  width: 0;\n  height: 0;\n  border-left: 14px solid transparent;\n  border-right: 14px solid transparent;\n  border-bottom: 14px solid #ddd;\n}\n\n/* Speech bubble for satisfied button */\n.speech-bubble-up-right::after {\n  content: '';\n  position: absolute;\n  top: -10px;\n  right: 20px;\n  width: 0;\n  height: 0;\n  border-left: 12px solid transparent;\n  border-right: 12px solid transparent;\n  border-bottom: 12px solid #ffffff;\n}\n\n.speech-bubble-up-right::before {\n  content: '';\n  position: absolute;\n  top: -12px;\n  right: 19px;\n  width: 0;\n  height: 0;\n  border-left: 14px solid transparent;\n  border-right: 14px solid transparent;\n  border-bottom: 14px solid #ddd;\n}\n\n.speech-bubble p {\n  margin: 0;\n  line-height: 1.3;\n  color: #333;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
